import common from "../common";
import {texture} from "p3";
import {iswebfont} from "../utils";
import GameScene from "../scenes/GameScene";

export default class CoinCounterPanel extends PIXI.Container {
    constructor() {
        super();

        this._coinAmount = common.saveData.activeSlot.coins;
        this._coinPanel = null;
        this._coinBag = null;
        this._coinIcon = null;
        this._coinLabel = null;

        this._tween = null;

        this.init();
    }

    init() {
        this._coinPanel = new PIXI.NineSlicePlane(texture("panel_coins"), 30, 0, 30, 0);
        this._coinPanel.position.set(-85, -36);
        this.addChild(this._coinPanel);

        this._coinBag = new PIXI.Sprite(texture("icon_coin_bag"));
        this._coinBag.x = -65;
        this._coinBag.anchor.set(0.5);
        this.addChild(this._coinBag);

        this._coinIcon = new PIXI.Sprite(texture("icon_coin"));
        this._coinIcon.anchor.set(0.5);
        this._coinIcon.x = -10;
        this._coinIcon.y = -2;
        this.addChild(this._coinIcon);

        if (!iswebfont()) {
            this._coinLabel = new PIXI.BitmapText(String(this._coinAmount), {
                fontName: "Alghera Pro",
                fontSize: 32,
                align: "left",
                tint: 0x000000
            });
        } else {
            this._coinLabel = new PIXI.Text(String(this._coinAmount), {
                fontFamily: "FredFredBurger",
                fontSize: 32,
                align: "left",
                fill: 0x0
            });
        }
        this._coinLabel.anchor.set(0, 0.5);
        this._coinLabel.x = 10;
        this._coinLabel.y = !iswebfont() ? 0 : -3;
        this.addChild(this._coinLabel);
    }

    update() {}

    destroy() {
        if (this._tween) {
            GameScene.active.removeTween(this._tween, true);
            this._tween = null;
        }

        super.destroy({ children: true });
    }

    promptMoneyBag() {
        P3.audio.playSound("sfx_btn_shop_no_cash");

        P3.audio.playSound([
            "vo_iv_oh_00",
            "vo_iv_oh_02"
        ]);

        this._tween = gsap.to(this._coinBag.scale, 0.15, {
            x: 1.1,
            y: 1.1,
            ease: Power1.easeInOut
        });
        this._tween = gsap.to(this._coinBag, 0.15, {
            rotation: 0.3,
            ease: Power1.easeInOut,
            yoyo: true,
            repeat: 3,
            onComplete: () => {
                this._tween = gsap.to(this._coinBag.scale, 0.15, {
                    x: 1,
                    y: 1,
                    ease: Power1.easeInOut
                });
            }
        });
        this._tween = gsap.to(this._coinPanel, 0.2, { pixi: {tint:0xc43f3f}, repeat:1, yoyo:true });

        GameScene.active.addTween(this._tween);
    }

    /**
     * @returns {number}
     */
    get coinAmount() {
        return this._coinAmount;
    }

    /**
     * @param {number} val
     */
    set coinAmount(val) {
        this._coinAmount = val;
        this._coinLabel.text = String(this._coinAmount);
        
        const rightPadding = 20;
        if (this._coinAmount > 999) {
            this._coinPanel.width = this._coinLabel.width + this._coinBag.width + this._coinIcon.width + rightPadding;
        }
    }
}
